"use client";

import type React from "react";
import { useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import { FilterOptions } from "./filterOptions";
import { useDebouncedSearch } from "common/hooks/src/useDebounce";

interface SearchAndFilterBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onFilterChange?: (filters: {
    dateRange?: { from: Date | null; to: Date | null } | null;
    status?: string | null;
    client?: string | null;
    priceRange?: { min: number | null; max: number | null } | null;
    city?: string | null;
  }) => void;
  type?: "devis" | "invoice" | "article" | "client" | "bon-commande";
}

const SearchAndFilterBar: React.FC<SearchAndFilterBarProps> = ({
  searchValue,
  onSearchChange,
  onFilterChange,
  type,
}) => {
  const [inputValue, setInputValue] = useState(searchValue);
  const debouncedSearch = useDebouncedSearch(inputValue, 300);

  // Update parent when debounced value changes
  useEffect(() => {
    onSearchChange(debouncedSearch);
  }, [debouncedSearch, onSearchChange]);

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3">
      {/* Search Input */}
      <div className="flex h-full min-w-[200px] flex-1 items-center rounded-full bg-lightPrimary py-3.5 text-navy-700 dark:bg-navy-900 dark:text-white">
        <p className="pl-3 pr-2 text-xl">
          <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
        </p>
        <input
          type="text"
          placeholder="Rechercher..."
          className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </div>

      {/* Filter Options - only show if onFilterChange and type are provided */}
      {onFilterChange && type && (
        <FilterOptions onFilterChange={onFilterChange} type={type} />
      )}
    </div>
  );
};

export default SearchAndFilterBar;
